import { Component, OnInit } from '@angular/core';
import { BookServiceService } from 'src/app/services/book-service.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-posts',
  templateUrl: './posts.component.html',
  styleUrls: ['./posts.component.scss']
})
export class PostsComponent implements OnInit { image: any;
  id: any;
  constructor(private Book: BookServiceService) {}
  data: {};
  title: any;
  description: any;

  AdminBooks: any;
  sub: Subscription;
  
  ngOnInit() {
    this.sub = this.Book.news().subscribe(data => {
      this.AdminBooks = data.map(el => {
        return {
          id: el.payload.doc.id,
          ...el.payload.doc.data()
        };
      });
    });
  }

  remove(id) {
    this.Book.removePost(id).catch(err => console.log(err));
  }
  onOpen(id: string) {
    this.Book.onePost(id).then(data => {
      this.title = data.title;
      this.description = data.description;
      this.image = data.image;
    });
  }
  done(id) {
    this.Book.editPost(id)
      .update({
        title: this.title,
        description : this.description,
        image : this.image,
      })
      .then(data => {
        console.log(this.title);
      });
    console.log(this.title);
  }

}
